export default __webpack_public_path__ + "static/media/campSpotIcon.32f98d70.svg";